<template>
  <div>
    <div class="content-table">
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%; "
          v-loading="listLoading"
          @cell-click="toggleSelection"
          @selection-change="selsChange"
          @header-click="selsAll"
          size="default"
          border
      >
        <!--            <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
        <el-table-column property="updateTime" label="更新时间" width="110"></el-table-column>
        <el-table-column property="validDate" label="生效时间" width="110"></el-table-column>
        <el-table-column property="endDate" label="终止时间" width="110"></el-table-column>
        <el-table-column property="washing" label="洗澡项目(元)" width="110"></el-table-column>
        <el-table-column property="washingRepurchase" label="复购奖励(元)" width="110"></el-table-column>
        <el-table-column property="increment" label="增值服务(%)" width="110"></el-table-column>
        <el-table-column property="goodSales" label="物品销售(%)" width="110"></el-table-column>
        <el-table-column property="liveSales" label="活体销售(%)" width="110"></el-table-column>
        <el-table-column property="other" label="其他(%)" ></el-table-column>
        <el-table-column property="userPay" label="客户充值(%)" width="120"></el-table-column>
        <el-table-column property="" label="操作">
          <template #default="scope">
            <el-button type="primary" @click="bonusEdit(scope.row)" size="small">编辑</el-button>
          </template>
        </el-table-column>
        <el-table-column property="adminName" label="添加人"></el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {getShopBonusHistoryPageList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BonusEditDialog from "@/views/shop/components/BonusEditDialog";

export default {
  name: "StatBonus",
  components: {},
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      bonusForm: this.value.bonusForm,

    }
  },
  methods: {


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.bonusForm.shopId;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopBonusHistoryPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          for(let i=0; i<this.pageDataList.length; i++) {
            if(i == 0) {
              this.pageDataList[i].endDate = this.upday(this.bonusForm.validDate)
            }else {
              this.pageDataList[i].endDate = this.upday(this.pageDataList[i-1].validDate)
            }
          }
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    //日期-1
    upday(time) {
      let T = new Date(time)
      let D = new Date()
      D.setDate(T.getDate() -1)
      let y = D.getFullYear()
      let m = D.getMonth() + 1
      let d = D.getDate()
      return y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    bonusEdit(row) {
      let bonusForm = Object.assign({}, row);
      Dialog.open({
        title: '门店【' + this.bonusForm.shopName + '】的提成',
        component: BonusEditDialog,
        data: {
          bonusForm: bonusForm,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
